import MainHeader from '../ReusableComponents/Header/MainHeader'
import PrgmSelection from '../ReusableComponents/PrgmSlider/PrgmSelection/PrgmSelection'

import appMenu from '../../Assets/appModeAi/hardwearMenu.png'
import renderPrgImage from '../../source/programImg'
import { useHistory } from 'react-router-dom'
import { connect } from 'react-redux'
import {
    getDeviceName,
    isAi1ShowCondition,
    stopByteCondition,
} from '../../utils/utils'
import DialogModal from '../ReusableComponents/DialogModal/DialogModal'
import { useEffect, useState } from 'react'
import { appAiBytesGeneration } from './AppModeAI/AppModeAiBytesGeneration'

function SelectCategory(props) {
    const history = useHistory()
    const connectedDevice = sessionStorage.getItem('connectedDevice')
    const deviceVersion = sessionStorage.getItem('deviceVersion')

    const [aiVersion, setAiVersion] = useState('')
    const [showDeviceNotConnect, setShowDeviceNotConnect] = useState(false)
    const [show_tost_text, setShow_tost_text] = useState({
        isShow: false,
        text: '',
    })
    // const [isShowLowerPcAiToolPopup, setIsShowLowerPcAiToolPopup] =
    //     useState(false)

    const item1Styl = {
        backgroundImage: `url("${renderPrgImage('chat')}")`,
        backgroundSize: '100% 100%',
        backgroundRepeat: 'no-repeat',
        pointerEvents: 'all',
        // cursor: 'pointer',

        height: '330px',
        width: '330px',

        display: 'flex',
        justifyContent: 'center',
        alignItems: 'end',
        position: 'relative',
        opacity: '0.5',
    }
    const item2Styl = {
        backgroundImage: `url("${renderPrgImage('train')}")`,
        backgroundSize: '100% 100%',
        backgroundRepeat: 'no-repeat',
        // cursor: 'pointer',

        height: '330px',
        width: '330px',

        display: 'flex',
        justifyContent: 'center',
        alignItems: 'end',
        position: 'relative',
    }

    const emptyDivStyle = {
        // backgroundColor: 'rgb(245, 211, 208, 0.5)',
        cursor: 'pointer',
        height: '174px',
        width: '193px',
        position: 'absolute',
        top: '54px',
        left: '50px',
    }

    const enterHardWearAi = () => {
        let sendStopBytes = stopByteCondition({
            connectedDevice,
            deviceVersion,
        })
        props.worker.postMessage({
            type: 'writeArray',
            value: sendStopBytes,
        })
    }

    const handelChatClick = () => {
        setShow_tost_text({
            isShow: true,
            text: ' The feature is not currently available for this device.Coming soon...',
        })
        setTimeout(
            () =>
                setShow_tost_text({
                    isShow: false,
                    text: '',
                }),
            2000
        )
        return

        if (props.webSerial.isConnected) {
            enterHardWearAi()
            history.push('/wifiSetting')
        } else {
            setShowDeviceNotConnect(true)
        }
    }
    const hardwareBtnClick = () => {
        if (props.webSerial.isConnected && aiVersion) {
            setShowDeviceNotConnect(false)
            enterHardWearAi()
            // history.push('/appMode/selectHardware')
            history.push('/chooseTrainingDevice')
        } else {
            setShowDeviceNotConnect(true)
        }
    }

    //get ai version
    useEffect(() => {
        try {
            let bytes = appAiBytesGeneration('aiVersionByte')
            if (props.webSerial.isConnected) {
                props.worker.postMessage({
                    type: 'WriteArrayFormat1310',
                    value: bytes,
                })
            }
        } catch (e) {
            console.log(e)
        }

        const messageHandler = (e) => {
            // if (e.data.type === 'read' && e.data.value.includes('AIXOK')) {
            if (e.data.type === 'actionRead') {
                let { arrayData, stringData } = e.data.value

                // sendDataAsPacket.current = false
                const pattern =
                    /65,76,(?:\d+,){2}63,((?:\d+,)*?)\d+,255,245(?:,\d+)*$/
                const match = arrayData.join(',').match(pattern)
                if (match && match[1]) {
                    const result = match[1]
                        .replace(/,$/, '')
                        .split(',')
                        .map(Number) // remove trailing comma if any
                    const versionString = String.fromCharCode(...result)
                    setAiVersion(versionString)
                }
            }
        }

        props.worker.addEventListener('message', messageHandler)

        return () => {
            props.worker.removeEventListener('message', messageHandler)
        }
    }, [props.webSerial.isConnected])

    return (
        <div>
            {/* Header */}
            <MainHeader
                help_btnPosition="right"
                helper={
                    <div
                        className="PS-S_slide"
                        style={{
                            left: '70%',
                            transform: 'translate(-50%)',
                        }}
                    >
                        <PrgmSelection />
                    </div>
                }
                goBack={() => {
                    // setSlideDirection(true)
                    // sessionStorage.setItem('slideDirection', true)
                    history.push('/Selection')
                }}
                isGoBack={true}
            />

            <div
                style={{
                    position: 'absolute',
                    top: '8.5%',
                    left: '12%',
                    transform: 'translate(-50%,-50%)',
                    // height: '22%',
                }}
            >
                <div style={{ position: 'relative' }}>
                    <img src={appMenu} style={{ width: '210px' }} />
                    <p
                        style={{
                            position: 'absolute',
                            left: '31%',
                            top: '37%',
                            color: 'white',
                            fontFamily: 'Halcyon_Regular',
                        }}
                    >
                        Hardware
                    </p>
                </div>
            </div>

            <DialogModal
                show={showDeviceNotConnect}
                text={`Please ensure the ${getDeviceName(
                    connectedDevice
                )} and AI-1 are connected before proceeding.`}
                showCloseBtn={true}
                handleDialogModalClose={() => setShowDeviceNotConnect(false)}
            />

            {/* <DialogModal
                show={isShowLowerPcAiToolPopup}
                text={
                    <p>
                        {`AI-1 accessory is not compatible with the current firmware version. Please update the ${getDeviceName(
                            connectedDevice
                        )} using the firmware updation tool `}
                        <a href="https://firmware.plode.org" target="_blank">
                            Here.
                        </a>
                    </p>
                }
                showCloseBtn={true}
                handleDialogModalClose={() =>
                    setIsShowLowerPcAiToolPopup(false)
                }
            /> */}

            <div
                style={{
                    height: '100vh',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                }}
            >
                <div style={item1Styl}>
                    <p
                        style={{
                            fontSize: '1.3rem',
                            paddingBottom: '120px',
                            paddingRight: '30px',
                        }}
                    >
                        Chat
                    </p>
                    <div
                        style={{ ...emptyDivStyle, cursor: 'default' }}
                        onClick={handelChatClick}
                    ></div>
                </div>
                <div style={item2Styl}>
                    <p
                        style={{
                            fontSize: '1.3rem',
                            paddingBottom: '120px',
                            paddingRight: '30px',
                        }}
                    >
                        Train
                    </p>
                    <div style={emptyDivStyle} onClick={hardwareBtnClick}></div>
                </div>
            </div>

            {show_tost_text.isShow && (
                <p className="comingSoon_text">{show_tost_text.text}</p>
            )}

            {aiVersion && (
                <p
                    style={{
                        textAlign: 'center',
                        position: 'fixed',
                        zIndex: '1',
                        right: '60px',
                        bottom: '5%',
                        // border: '1px solid red',
                        // transform: 'translate(-50%, -50%)',
                    }}
                >
                    AI Firmware Version : {aiVersion}
                </p>
            )}
        </div>
    )
}

const mapStateToProps = (state) => {
    return {
        webSerial: state.webSerial,
        worker: state.worker,
        isConnecting: state.isConnecting,
        languageName: state.device.language,
    }
}

export default connect(mapStateToProps)(SelectCategory)
